module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user) ? _c('b-col', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-fluid profilePic mb-3",
    attrs: {
      "src": _vm.user.photoURL
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.user.displayName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.email))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d68695f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 659
// module chunks = 1